"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_KIND_CODES = exports.SUPPORT_REPLY_MAX_LENGTH = exports.SupportAttachmentSchema = exports.SupportTicketOriginSchema = exports.SUPPORT_TICKET_ORIGINS = exports.SupportReferenceKindSchema = exports.SUPPORT_REFERENCE_KINDS = exports.SupportCategorySchema = exports.SUPPORT_CATEGORIES = exports.SupportTicketStatusSchema = exports.SUPPORT_TICKET_STATUSES = void 0;
exports.supportStartParam = supportStartParam;
exports.parseSupportStartParam = parseSupportStartParam;
const zod_1 = require("zod");
exports.SUPPORT_TICKET_STATUSES = ['open', 'pending', 'closed'];
exports.SupportTicketStatusSchema = zod_1.z.enum(exports.SUPPORT_TICKET_STATUSES);
exports.SUPPORT_CATEGORIES = ['deposit', 'withdrawal', 'exchange', 'other'];
exports.SupportCategorySchema = zod_1.z.enum(exports.SUPPORT_CATEGORIES);
exports.SUPPORT_REFERENCE_KINDS = ['deposit', 'withdrawal', 'exchange'];
exports.SupportReferenceKindSchema = zod_1.z.enum(exports.SUPPORT_REFERENCE_KINDS);
exports.SUPPORT_TICKET_ORIGINS = ['bot', 'mini_app', 'staff'];
exports.SupportTicketOriginSchema = zod_1.z.enum(exports.SUPPORT_TICKET_ORIGINS);
/** Telegram identifiers and metadata only; the bytes stay at Telegram (spec 2026-10-28 §3). */
exports.SupportAttachmentSchema = zod_1.z.object({
    kind: zod_1.z.enum(['photo', 'document']),
    fileId: zod_1.z.string().min(1),
    fileUniqueId: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().nullable(),
    fileName: zod_1.z.string().nullable(),
    size: zod_1.z.number().int().nonnegative().nullable(),
    width: zod_1.z.number().int().positive().nullable(),
    height: zod_1.z.number().int().positive().nullable(),
});
/** Longest staff reply the admin accepts; the Telegram cap is 4096 and the header takes some. */
exports.SUPPORT_REPLY_MAX_LENGTH = 3500;
exports.SUPPORT_KIND_CODES = {
    deposit: 'd',
    withdrawal: 'w',
    exchange: 'x',
};
const CODE_KINDS = {
    d: 'deposit',
    w: 'withdrawal',
    x: 'exchange',
};
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const SUPPORT_START_PAYLOAD = new RegExp(`^sup_([dwx])_(${UUID})$`);
/**
 * `/start` payload that pre-attaches an operation to the user's next ticket (spec 2026-10-28
 * §5.2). 42 characters of `[A-Za-z0-9_-]`, inside Telegram's 64-character limit.
 */
function supportStartParam(kind, id) {
    return `sup_${exports.SUPPORT_KIND_CODES[kind]}_${id}`;
}
function parseSupportStartParam(payload) {
    const match = SUPPORT_START_PAYLOAD.exec(payload);
    if (!match)
        return null;
    return { kind: CODE_KINDS[match[1]], id: match[2] };
}
//# sourceMappingURL=support.js.map